var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"totop"},[_c('div',{staticClass:"topItem",on:{"click":_vm.totop}},[_c('img',{attrs:{"src":require("@/images/totop.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }